/**
 * Response header every Postgres-backed delta-sync (`since=`) endpoint sets:
 * an ISO timestamp at or before which every row is guaranteed to be both
 * committed and included in the response (given the request's `since`).
 *
 * Needed because synced `update_date`s are stamped with `NOW()` - the
 * writing transaction's *start* time - so a row can commit long after rows
 * dated later than it, and the newest `updateDate` a client has seen isn't
 * a safe cursor on its own. A client advances its cursor to this horizon
 * instead (never past it), which also gives it a server-clock cursor when a
 * pull returns nothing. Absent on endpoints that can't compute one.
 */
export const SYNC_HORIZON_HEADER = 'X-Sync-Horizon';
